import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FiltersService } from 'src/app/services/filters.service';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';
import { PencilPillComponent } from '../pencil-pill/pencil-pill.component';
import { FilterData, IFilterPill } from '../generic-filters-view/filters.interface';
import { TooltipDirective } from '../../directives/pncl-tooltip.directive';
import { IconTypes } from '../pencil-icon/pencil-icon.component';

@Component({
  selector: 'app-applied-filter-pills',
  templateUrl: './applied-filter-pills.component.html',
  styleUrls: ['./applied-filter-pills.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PencilButtonComponent,
    PencilPillComponent,
    TranslateModule,
    TooltipDirective,
  ],
})
export class AppliedFilterPillsComponent {
  public filterPills$: Observable<IFilterPill[]>;
  public hasClearableFilters$: Observable<boolean>;

  readonly IconTypes = IconTypes;

  constructor(public filtersService: FiltersService) {
    this.filterPills$ = this.filtersService.appliedFilters$.pipe(
      map((filters: FilterData[]) => filters.map((filter) => filter.getFilterPill())),
    );
    this.hasClearableFilters$ = this.filtersService.hasClearableFilters$;
  }

  clearFilterPill(filterPill: IFilterPill): void {
    this.filtersService.removeFilter(filterPill.key);
  }

  clearFilters(): void {
    this.filtersService.clearFilters();
  }
}
